import { EnvironmentProviders, inject, NgModule, Provider, provideAppInitializer } from "@angular/core";
import { provideTranslateService, TranslateDirective, TranslatePipe, TranslateService } from "@ngx-translate/core";

import { fr } from "src/app/i18n/fr.lang";
import { en } from "src/app/i18n/en.lang";
import { AuthService } from "./services/auth.service";

/** The translate pipe and directive (standalone since ngx-translate 17) for the NgModule templates. */
@NgModule({
    imports: [TranslatePipe, TranslateDirective],
    exports: [TranslatePipe, TranslateDirective]
})
export class AppTranslateModule { }

/**
 * One TranslateService for the whole app, fed with the bundled dictionaries
 * (src/app/i18n), in the user's language once logged in.
 */
export function provideAppTranslation(): (Provider | EnvironmentProviders)[] {
    return [
        provideTranslateService({ fallbackLang: "fr" }),
        provideAppInitializer(() => {
            const translate = inject(TranslateService);
            const s_auth = inject(AuthService);

            translate.addLangs(["en", "fr"]);
            translate.setTranslation("fr", fr);
            translate.setTranslation("en", en);

            // Use user's preferred language if logged in, otherwise fall back to browser language
            if (s_auth.user) {
                translate.use(s_auth.user.lang);
            } else {
                const browserLang = translate.getBrowserLang();
                translate.use(browserLang?.match(/en|fr/) ? browserLang : "fr");
            }

            // Subscribe to user changes to update language when user logs in
            s_auth.onAuthenticated.subscribe(user => {
                if (user?.lang && user.lang !== translate.getCurrentLang()) {
                    translate.use(user.lang);
                }
            });
        })
    ];
}
